import { createSlice } from "@reduxjs/toolkit";

export const bankerAuthSlice = createSlice({
  name: "bankerAuth",
  initialState: {
    user: null,
    accessToken: null,
    loginDate: null,
    bank: null,
    currentBranch: null,
    redirectUrl: null,
    bankerHasSwissEvents: null,
  },

  reducers: {
    setBankerUser: (state, action) => {
      state.user = action.payload;
    },

    setBankerTokens: (state, action) => {
      state.accessToken = action.payload.access_token;
    },

    setBankerLoginDate: (state, action) => {
      state.loginDate = action.payload.loginDate;
    },

    setBank: (state, action) => {
      state.bank = action.payload;
    },

    setCurrentBranch: (state, action) => {
      state.currentBranch = action.payload;
    },

    setBankerRedirectUrl: (state, action) => {
      state.redirectUrl = action.payload;
    },

    setBankerHasSwissEvents: (state, action) => {
      state.bankerHasSwissEvents = action.payload;
    },

    clearBankerRedirectUrl: (state) => {
      state.redirectUrl = null;
    },

    clearBankerAuth: (state) => {
      state.user = null;
      state.accessToken = null;
      state.loginDate = null;
      state.currentBranch = null;
      state.redirectUrl = null;
      state.bankerHasSwissEvents = null;
    },
  },
});

export const {
  setBankerUser,
  setBankerTokens,
  setBankerLoginDate,
  clearBankerAuth,
  setBank,
  setCurrentBranch,
  setBankerRedirectUrl,
  clearBankerRedirectUrl,
  setBankerHasSwissEvents,
} = bankerAuthSlice.actions;

export default bankerAuthSlice.reducer;
